angular.module('omfm').service('SaoCompany', SaoCompanyService);

SaoCompanyService.$inject = ['$resource', 'ServerInterceptor'];

function SaoCompanyService($resource, ServerInterceptor) {
	return $resource('/sao', {"id": "@id"}, {
		'list':{
			'url':'/sao/company',
			'method': 'get',
			'interceptor': ServerInterceptor,
			'isArray': true
		},
		'letters':{
			'url':'/sao/company/:id/letters',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'save':{
			'url':'/sao/company/:id',
			'method': 'post',
			'interceptor': ServerInterceptor
		}
	})
}